module.exports = __webpack_public_path__ + "images/emoji/rocket.b5a40d7ecfd44b41c23c.png";